// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div#driver-popover-item{border-radius:6px}div#driver-page-overlay{background-color:#b8b8b8}div#driver-highlighted-element-stage{height:50px!important}", ""]);
// Exports
module.exports = exports;
